import { PageBuilder, PageParts } from '@spa/components/pages/paid-membership/change/model/page-builder'
import AfterPlanAlreadySubscribed from '@spa/components/pages/paid-membership/change/model/page/caption/common/AfterPlanAlreadySubscribed.vue'
import BeforePlanNotSubscribed from '@spa/components/pages/paid-membership/change/model/page/caption/common/BeforePlanAlreadyUnsubscribed.vue'
import ChangeForbidden from '@spa/components/pages/paid-membership/change/model/page/caption/common/ChangeForbidden.vue'
import InitializeFailed from '@spa/components/pages/paid-membership/change/model/page/caption/common/InitializeFailed.vue'
import ChangeFailed from '@spa/components/pages/paid-membership/change/model/page/caption/downgrade/ChangeFailed.vue'
import ChangeSucceed from '@spa/components/pages/paid-membership/change/model/page/caption/downgrade/ChangeSucceed.vue'
import InitializeSucceed from '@spa/components/pages/paid-membership/change/model/page/caption/downgrade/InitializeSucceed.vue'
import AllowedToChange from '@spa/components/pages/paid-membership/change/model/page/form/AbleToChange.vue'
import DisallowedToChange from '@spa/components/pages/paid-membership/change/model/page/form/DisableToChange.vue'
import { State } from '@spa/components/pages/paid-membership/change/model/state'
import Vue from 'vue'

export const downgradePageBuilder: PageBuilder = {
  buildFor(s: State): PageParts {
    switch (s) {
      case 'initialize-failed':
        return {
          caption: InitializeFailed,
          form: DisallowedToChange,
        }
      case 'before-plan-not-subscribed-now':
        return {
          caption: BeforePlanNotSubscribed,
          form: DisallowedToChange,
        }
      case 'after-plan-already-subscribed':
        return {
          caption: AfterPlanAlreadySubscribed,
          form: DisallowedToChange,
        }
      case 'change-forbidden':
        return {
          caption: ChangeForbidden,
          form: DisallowedToChange,
        }
      case 'initialize-succeed':
        return {
          caption: InitializeSucceed,
          form: AllowedToChange,
        }
      case 'change-succeed':
        return {
          caption: ChangeSucceed,
          form: DisallowedToChange,
        }
      case 'change-failed':
        return {
          caption: ChangeFailed,
          form: AllowedToChange,
        }
      case 'not-initialized':
      case 'loading':
        return {
          caption: Vue.extend({
            template: '<div></div>',
          }),
          form: DisallowedToChange,
        }
    }
  },
}
